var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block"},[_c('el-carousel',{attrs:{"interval":_vm.interval,"arrow":"always","height":"550px"},on:{"change":_vm.handleCarouselChange}},_vm._l((_vm.listActives),function(item){return _c('el-carousel-item',{key:item.id},[_c('img',{attrs:{"src":item.image}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }